import { Flex } from "antd";
import { observer } from "mobx-react-lite";

import { CustomButton } from "ui";
import { useStores } from "stores";
import { ConfirmOtpModal } from "components/ConfirmOtpModal";
import { OPERATION_TYPE } from "interfaces";
import { CustomerExecutionModalBody } from "./CustomerExecutionModalBody";

export const CustomerExecutionModal = observer(() => {
  const { actionModals } = useStores();

  function closeModalHandler() {
    actionModals.closeAll();
  }

  function openOtpModalHandler() {
    actionModals.open(
      () => (
        <ConfirmOtpModal
          operationPath={OPERATION_TYPE.CUSTOMER_EXECUTION}
          description={<CustomerExecutionModalBody isExecuteModal={true} showAddressWallet={true} />}
          cancelBtnProps={{
            position: "bottom",
          }}
        />
      ),
      {
        title: "Согласие на исполнение заявки",
        width: "700px",
      }
    );
  }
  return (
    <Flex vertical gap="large">
      <CustomerExecutionModalBody isExecuteModal={true} showAddressWallet={true} />
      <Flex gap="small">
        <CustomButton className="full-width" variant="outlined" onClick={closeModalHandler}>
          Отменить
        </CustomButton>
        <CustomButton className="full-width" onClick={openOtpModalHandler}>
          Подтвердить
        </CustomButton>
      </Flex>
    </Flex>
  );
});
